import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  toolbarContainer: {
    display: "flex",
    alignItems: "center",
    padding: "2px 0",
    minHeight: "48px",
    width: "100%",
    flexWrap: "nowrap",
  },
  datagridContainer: {
    flex: 1,
    maxHeight: "100%",
    width: "100%",
    minHeight: "300px",
    overflow: "auto",
    // Hide column separator for the last column
    "& .MuiDataGrid-columnHeader--last .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row--borderBottom .MuiDataGrid-filler": {
      borderBottom: "none !important",
    },
    "& .copyable-cell .copy-icon": {
      display: "inline-flex",
      opacity: 0,
      transition: "opacity 120ms ease-in-out",
      pointerEvents: "none",
    },
    "& .copyable-cell:hover .copy-icon": {
      opacity: 1,
      pointerEvents: "auto",
      color: theme.palette.text.primary,
    },
    "& .MuiDataGrid-root": {
      height: "100% !important",
      maxHeight: "100% !important",
      display: "flex",
      flexDirection: "column",
    },
    "& .MuiDataGrid-main": {
      flex: "1 1 auto",
      overflow: "auto",
      minHeight: 0,
    },
    "& .MuiDataGrid-virtualScroller": {
      flex: "1 1 auto",
      overflow: "auto",
    },
    "& .MuiDataGrid-footerContainer": {
      flex: "0 0 auto",
      minHeight: "52px",
    },
  },
  cellContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    overflow: "hidden",
  },
  cellContent: {
    flex: 1,
    overflow: "hidden",
    wordBreak: "break-word",
    minWidth: 0,
  },
  cellCopyIcon: {
    flexShrink: 0,
    pointerEvents: "none",
  },
  dialogRoot: {
    minWidth: 400,
    minHeight: 20,
    paddingBottom: 2,
  },
  dialogContentContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dialogTitle: {
    marginBottom: 0,
    fontWeight: "bold",
    marginTop: -32,
    width: "85%",
  },
  dialogContent: {
    padding: 20,
    fontSize: 16,
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 6,
  },
  dialogButtons: {
    display: "flex",
    flexWrap: "wrap-reverse",
    justifyContent: "flex-end",
  },
  dialogButton: {
    marginRight: 10,
    fontSize: 14,
  },
  rowContainer: {
    display: "flex",
    alignItems: "center",
  },
  cellFocus: {
    cursor: "pointer",
    width: "20vw",
  },

  dataMgtSelect: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  resize: {
    fontSize: "1.3rem",
    fontWeight: "500",
    whiteSpace: "nowrap",
    marginLeft: "8px",
  },
  datePicker: {
    padding: 4,
    width: 120,
    height: 26,
  },
  timePicker: {
    padding: 4,
    width: 90,
    height: 26,
  },
  recDatePicker: {
    width: 120,
    height: 26,
  },
  boderColor: {
    border: `1px solid ${theme.palette.redAlert[50]}`,
  },
  disabledBox: {
    pointerEvents: "none",
    opacity: 0.5,
  },
});

export default styles;
